import { getUrlScheme } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { APIService } from '../../../api.service';
import { CommonService } from '../../../services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-tranjections-print',
  templateUrl: './tranjections-print.component.html',
  styleUrls: ['./tranjections-print.component.scss']
})
export class TranjectionsPrintComponent implements OnInit {

  constructor(private apiService: APIService,private commonService: CommonService,private CmnService : CommonService,
    private SpinnerService: NgxSpinnerService) { }
  agencyData: any = [];
  jarvisData: any = [];
  AgcData: any = []; 
  tranjectionData: any = [];
  items: any = [];
  configData: any = [];
  userData: any = [];
  reletivesData: any = [];
  ordersData: any = [];
  localItems: any = [];
  storeName: any = '';
  recieveBy: string = '';
  supplire: string = '';
  AgencyName: string = '';
  City : string = '';
  State: string = '';
  printHeaderImg: any = '';
  cusHeader : any = [];
  orderNo: number = 0;
  orderDate: string = '';
  total: number = 0;
  outStoreName: string = '';
  CompanyName : string = '';
  Name : string = '';
  excecutiveName : string = '';
  issueToUser :  string = ' ';
  toUserName : string = '';
  recieveFrom : string = '';
  showBlod: boolean = false;
  wipShow : boolean = false;
  categories: Array<any> = [];
  printHeader: string = "";
  gstLocations: Array<any> = [];
  tranjection: any = {
    GRNNo: 0,
    Date: '',
    RefNo: 0,
    InStore: '',
    UserID: 0,
    RelID: 0,
    Ref: '',
    XnTypeID: 0,
    XnFields: [],
    XnNotes : ''
  }  
  add: any = {
    Name: '',
    Line1: '',
    Line2: '',
    City: '',
    Pin: '',
    GSTIN: '',
    State: ''
  }

  customHeader : any = {
    cmpLogo: '',
    cmpName: '',
    gstin: '',
    cin: '',
    address: '',
    mobile: '',
    showLogo: false,
    side: 1
  }

  name : string = '';
  addShow : boolean = false;
  unitList: Array<any> = [];
  suppShow : boolean = false;
  // itemcode : string = '';
  storeLocID : number = 0;
  compName: string = '';
  compRelName: string = '';
  compAddr: string = '';
  isB2C: boolean = false;  

  ngOnInit(): void {
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      if(this.agencyData){
      this.printHeaderImg = this.agencyData[0].Letterhead;
      this.cusHeader = this.agencyData[0].PHJSON;
      this.isB2C = this.agencyData[0].IsB2C;
      
      console.log('phjson', this.cusHeader);
      if(this.cusHeader != '[]' && this.cusHeader != ""){
        this.cusHeader = JSON.parse(this.cusHeader);
        this.customHeader.cmpName = this.cusHeader[0].cnm;
        this.customHeader.gstin = this.cusHeader[0].gstin ? this.cusHeader[0].gstin : this.agencyData[0].GSTIN;
        this.customHeader.cin = this.cusHeader[0].cin;
        this.customHeader.address = this.cusHeader[0].add;
        this.customHeader.mobile = this.cusHeader[0].cno;
        this.customHeader.showLogo = this.cusHeader[0].inlHdr;
        this.customHeader.side = this.cusHeader[0].side;
        this.customHeader.cmpLogo = this.agencyData[0].Logo;
      }
    }
  }

    this.getData();
  }

  printTranjection(){
    setTimeout(function () {
      var mainContain = $('body').html();
      var printArea = $('#tranjections').html();
      $('body').html(printArea); 
      window.print(); 
  }, 400);
  }

  
  getData(){
    let XnID =  this.commonService.encryptData(this.commonService.GetParam('XnID'));
    let agencyID: any = this.commonService.encryptData(this.commonService.GetParam('aid'));
    var tempData = [{
      'XnID': XnID,
      'AgencyID': agencyID
  }]
    let myParams = [{
        myUserID: 0,
        myToken: '',
        forAgencyID: agencyID,
        myAgencyIDs: agencyID, 
        ForERPAgencyID: 0,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getXnDetailsExt',
        moduleID: 11,
        data: JSON.stringify(tempData)
    }];
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
    }
  
  getItemData() {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let data = [{
      StatusID: 1,
      StoreID: 0,
      IsFromList: 1
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'get',
      moduleID: 5,
      data: JSON.stringify(data)
    }];
    this.SpinnerService.show();
    this.apiService.getData(myParams, this.successRespItem.bind(this), this.failureRespItem.bind(this));
  }

   //successResp - success  get handler
   successRespItem(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        let StoreID: number = 0;
        debugger
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          let data = reponseData;
          let tempItems = data.Table1;
          let Items: any = tempItems.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));
          
          for (let x = 0; x < Items.length; x++) {
            if (Items[x].StoreBatches) {
              let tempData = JSON.parse(Items[x].StoreBatches)
              let tempQTY = tempData.filter((x: any) => x.SID == StoreID)
              if (tempQTY.length > 0) {
                Items[x].CurrQty = Number(tempQTY[0].Q).toFixed(Items[x].SKUPrecision)
              } else {
                Items[x].CurrQty = 0
              }
            } else {
              Items[x].CurrQty = Number(Items[x].CurrQty).toFixed(Items[x].SKUPrecision)
            }
            Items[x].TotalValue = Number(Items[x].CurrQty) * Number(Items[x].DefStockRate)
            if (Items[x].CID > 0) {
              for (let i = 0; i < this.categories.length; i++) {
                if (Items[x].CID == this.categories[i].cid) {
                  if(this.categories[i].cnm){
                    Items[x].CN = this.categories[i].cnm;
                  }
                  else{
                    Items[x].CN = '';
                  }
                   let subCategory = this.categories.filter((A: any) => A.cid == Items[x].CID)
                   if(subCategory[0].sub){
                      let tempSubCat = subCategory[0].sub.filter((s: any) => s.sid == Items[x].SCID)
                      if (tempSubCat.length > 0) {
                        Items[x].SC = tempSubCat[0].snm
                      }
                      else {
                        Items[x].SC = ''
                      }
                   }
                   else{
                    Items[x].SC = ''
                   }                  
                }               
              }
            }
            else {
              Items[x].CN = ''
            }

            Items[x].SCN = (Items[x].CN == '' ? '-' : Items[x].CN) + (Items[x].SC ? ' / ' : '') + (Items[x].SC ? Items[x].SC : '');
           
          }

          this.localItems = Items
          this.getData();
        }
      }
    }
  }

  //failureResp - failure handler
  failureRespItem(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
      console.log(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

//successResp - success  get handler
successResp(res: any) {
  if (res.error) {
      
  }
  else {
      if (res) {
        debugger;
          var reponseData = JSON.parse(res.updatePackage);
          if(reponseData.Table[0].ErrCode != -1){
            this.apiService.successAlert(reponseData.Table[0].ErrMsg);
          }
          else {
            //Own Agency Data
            this.agencyData = reponseData.Table1;
            this.City = this.agencyData[0].City;
            this.State = this.agencyData[0].State;
            this.AgencyName = this.agencyData[0].AgencyName;
            if(this.agencyData[0].Letterhead){
              if(this.apiService.fn_isLiveURL() == true){
                this.printHeader = "https://biziverse.com/" + this.agencyData[0].Letterhead;
              }
              else{
                this.printHeader = "http://localhost/" + this.agencyData[0].Letterhead;
              }
            }
            let locs = this.agencyData[0].Locations ? this.agencyData[0].Locations : '[]';
            if (locs) {
              this.gstLocations = JSON.parse(locs);
              this.gstLocations = this.gstLocations.filter(o => o.IsD == false);
            }
            let enblMultiLocation = this.agencyData[0].EGST ? this.agencyData[0].EGST : 0;
            

            //Own Agency's Config Data
            this.configData = reponseData.Table2;
            this.unitList = JSON.parse(this.configData[0].Units);
            if(this.configData[0].ItemCategories){
              this.categories = JSON.parse(this.configData[0].ItemCategories)
            }

            // Own Agency's Users
            this.userData = reponseData.Table3;
            var batches = [];
            if (reponseData.Table4) {
              var editDataArry = [];
                editDataArry = reponseData.Table4[0];
                this.tranjection = {
                  GRNNo: editDataArry.XnNo,
                  Date: editDataArry.XnDate,
                  RefNo: editDataArry.XnNo,
                  InStore: editDataArry.InStoreID,
                  OutStore: editDataArry.OutStoreID,
                  UserID: editDataArry.UserID,
                  RelID: editDataArry.RelID,
                  Ref: editDataArry.Reference,
                  XnTypeID: editDataArry.XnTypeID,
                  ExecUserID :editDataArry.ExecUserID,
                  XnNotes : editDataArry.XnNotes,
                  PrdJobNo : editDataArry.PrdJobNo,
                  XnFields: editDataArry.XnFields == "" ? [] : JSON.parse(editDataArry.XnFields)
                }

                if(this.tranjection.XnTypeID == 1  || this.tranjection.XnTypeID == 5 || this.tranjection.XnTypeID == 9 || this.tranjection.XnTypeID == 7 || this.tranjection.XnTypeID == 4  || this.tranjection.XnTypeID == 2 || this.tranjection.XnTypeID == 12 || this.tranjection.XnTypeID == 13){
                  // var id = (this.tranjection.InStore && this.tranjection.InStore > 0) ? this.tranjection.InStore : this.tranjection.OutStore;
                  var id: number = 0;
                  /*if(this.tranjection.InStore > 0 && this.tranjection.InStore != ''){
                    id = this.tranjection.InStore;
                  }
                  else {
                    id = this.tranjection.OutStore;
                  }*/
                 
                  // 1: Inward History, 2: Return History, 4: Dispatch, 5: Material Issue, 7: Production History, 9: Store Transfer
                  if (this.tranjection.XnTypeID == 1 || this.tranjection.XnTypeID == 2 || this.tranjection.XnTypeID == 7 || this.tranjection.XnTypeID == 9 || this.tranjection.XnTypeID == 12 || this.tranjection.XnTypeID == 13) {
                    id = this.tranjection.InStore;
                  } 
                  else if (this.tranjection.XnTypeID == 4 || this.tranjection.XnTypeID == 5) {
                    id = this.tranjection.OutStore;
                  }
                  var stores = JSON.parse(this.configData[0].Stores)
                  var storeData = stores.filter(function (element: any, index: any) {
                    return (element.StrID == id);
                  });
  
                  if (storeData.length > 0) {
                    this.storeName = storeData[0].sNm;
                    this.storeLocID = storeData[0].LID ? storeData[0].LID : 0
                  }
                  else{
                    this.storeName = "-";
                    this.storeLocID = 0
                  }
                  
                  var uId = this.tranjection.UserID
                  var Users = this.userData.filter(function (element: any, index: any) {
                    return (element.UserID == uId);
                  });
                
                  if(Users.length > 0){
                    this.recieveBy = Users[0].Name;
                  }
                  else{
                    this.recieveBy = "-";
                  }
  
                  // var orderId = this.tranjection.OrderID;
                  // var tempOrdersData = this.ordersData.filter(function (element: any, index: any) {
                  //   return (element.OrderID == orderId);
                  // });

                  // if(tempOrdersData.length > 0){
                  //   this.orderNo = tempOrdersData[0].OrderID;
                  //   this.orderDate = tempOrdersData[0].OrderDate;
                  // }

                  this.orderNo = editDataArry.OrderNo
                  this.orderDate = editDataArry.OrderDate
                  
                }

                // XnTypeID: 5 (Material issue - Receive from User)
                /*if (this.tranjection.XnTypeID == 5 && this.tranjection.OutStore) {
                  storeData = stores.filter((e: any) => e.StrID == this.tranjection.OutStore);
                  if (storeData.length > 0) {
                    this.storeName = storeData[0].sNm ? storeData[0].sNm : '-';
                    this.storeLocID = storeData[0].LID ? storeData[0].LID : 0;
                  }
                }*/

                if (this.storeLocID > 0 && this.gstLocations.length > 0 && enblMultiLocation) {
                  let selectedLoc = this.gstLocations.filter((l: any) => l.ID == this.storeLocID);
                  if (selectedLoc.length > 0) {
                    this.customHeader.cmpName = selectedLoc[0].Nm ? selectedLoc[0].Nm : this.customHeader.cmpName;
                    this.customHeader.gstin = selectedLoc[0].GST ? selectedLoc[0].GST : this.customHeader.gstin;
                    this.customHeader.cin = selectedLoc[0].CIN ? selectedLoc[0].CIN : this.customHeader.cin;
                    this.customHeader.address = selectedLoc[0].Addr ? selectedLoc[0].Addr : this.customHeader.address;
                    this.customHeader.mobile = selectedLoc[0].CI ? selectedLoc[0].CI : this.customHeader.mobile;
                    this.customHeader.showLogo = this.cusHeader[0].inlHdr;
                    this.customHeader.side = this.cusHeader[0].side;
                    this.customHeader.cmpLogo = this.agencyData[0].Logo;

                    //Own Agency Data
                    this.City = selectedLoc[0].CT ? selectedLoc[0].CT : this.City;
                    this.State = selectedLoc[0].SNm ? selectedLoc[0].SNm : this.State;
                    this.AgencyName = selectedLoc[0].Nm ? selectedLoc[0].Nm : this.AgencyName;
                    if(selectedLoc[0].Hdr){
                      if(this.apiService.fn_isLiveURL() == true){
                        this.printHeader = "https://biziverse.com/" + selectedLoc[0].Hdr;
                      }
                      else{
                        this.printHeader = "http://localhost/" + selectedLoc[0].Hdr;
                      }
                    }
                  }
                }

               //  executive CompanyName  & Name get
                // var relid = this.tranjection.RelID;
                // var reletives = this.reletivesData.filter(function (element: any) {
                //   return(element.RelativeID == relid)
                // });
                // if(reletives.length > 0){
                //   this.excecutiveName = reletives[0].Cmp;
                //   // this.toUserName = reletives[0].Name;
                // }
                // else{
                //   this.excecutiveName = "-";
                // }
                
                // this.excecutiveName = editDataArry.RelCmpName;
               if(this.isB2C) {
                  this.excecutiveName =  editDataArry.RelContactName ? editDataArry.RelContactName : editDataArry.RelCmpName;
               }
               else {
                  this.excecutiveName = String(editDataArry.RelCmpName).trim() == "-" ? editDataArry.RelContactName : editDataArry.RelCmpName;
               }
                this.compName = String(editDataArry.RelCmpName).trim();
                this.compRelName = String(editDataArry.RelContactName).trim();
                //out store 
                var FStore = editDataArry.OutStoreID;
                var IStore = stores.filter(function(element : any){
                  return(element.StrID == FStore)
                });
                if(IStore.length > 0){
                this.outStoreName = IStore[0].sNm;
                }
                else{
                  this.outStoreName = "-";
                }
                
                // User Name Get From User.
                var executiveID = this.tranjection.ExecUserID;
                let selectedExecutive = $.grep(this.userData, function(o: any){ return o.UserID == executiveID});
                if(selectedExecutive.length > 0){
                  this.toUserName = selectedExecutive[0].Name;
                }
                else {
                  this.toUserName = '';
                }
               
  
                // Adress get
                if(editDataArry.RelAddress){
  
                  this.addShow = true;
                  var AddressData = JSON.parse(editDataArry.RelAddress)
                  this.add = {
                    Name: AddressData.AddrName,
                    Line1: AddressData.Line1,
                    Line2: AddressData.Line2,
                    City: AddressData.City,
                    Pin: AddressData.Pincode,
                    GSTIN: AddressData.GSTIN,
                    State: AddressData.State
                  }
                }
              
                if(reponseData.Table4){
                   var itemData = reponseData.Table4;

                   itemData.forEach((a: any) => {	
                    var btchStr: any = "";
                    if((a.BatchType == 1 || a.BatchType == 2) && a.XnBInfo){
                      batches = JSON.parse(a.XnBInfo);
                      for(let i = 0; i < batches.length; i++){
                        // btchStr = btchStr + batches[i].B + " (" + batches[i].Q + ") , ";
                        let batchName = batches[i].B;
                        let batchQty = batches[i].Q;
                        let coma = ', ';

                        if(i != (batches.length - 1)){
                          btchStr = btchStr + batchName + " (" + batchQty + ")" + coma
                        }
                        else{
                          btchStr = btchStr + batchName + " (" + batchQty + ")" 
                        }
                      }
                      a.btchStr = btchStr;
                    }
                  });


                  for(let i = 0; i < itemData.length; i++){
                    // let iID = itemData[i].IID;
                    // var tempItems = this.localItems.filter(function (element: any, index: any) {
                    //   return (element.ItemID == iID);
                    // });
    
                    let selectedUnit: Array<any> = $.grep(this.unitList, function(o: any){ return o.UNm == itemData[i].Unit});
                    
                    let precision: number = 0;
                    if(selectedUnit.length > 0){
                      precision = selectedUnit[0].Prcsn;
                    }
                 
                    let temp = {
                      IID: itemData[i].ItemID,
                      ItemName: itemData[i].ItemName,
                      ItemCode : itemData[i].ItemCode,
                      IQ: this.commonService.PrecisionwiseValue(itemData[i].IQty + "", precision, true),
                      ISID: itemData[i].IStrID,
                      OQ: this.commonService.PrecisionwiseValue(itemData[i].OQty + "", precision, true),
                      OSID: itemData[i].OStrID,
                      Notes : itemData[i].Notes,
                      Rate: itemData[i].Rate,
                      Rto: itemData[i].Rto,
                      SrNo: itemData[i].SrNo,
                      TID: itemData[i].TID,
                      Unit: itemData[i].Unit,    
                      Total: itemData[i].OQty * itemData[i].Rate,
                      BatchType:  itemData[i].BatchType,
                      btchStr:  itemData[i].btchStr
                    }
    
    
                    if((this.tranjection.XnTypeID == 9 || this.tranjection.XnTypeID == 1 || this.tranjection.XnTypeID == 2 || this.tranjection.XnTypeID == 7 || this.tranjection.XnTypeID == 12 || this.tranjection.XnTypeID == 13) && itemData[i].IQty > 0){
                      this.items.push(temp);
                    }
                    else if(this.tranjection.XnTypeID != 9 || this.tranjection.XnTypeID != 1 || this.tranjection.XnTypeID != 2 || this.tranjection.XnTypeID != 7) {
                   
                    }
                    
                    if((this.tranjection.XnTypeID == 5 || this.tranjection.XnTypeID == 4) && itemData[i].OQty > 0){
                      this.items.push(temp);
                    }
                    else if(this.tranjection.XnTypeID != 5 || this.tranjection.XnTypeID != 4) {
                    
                    }
                  }
                }              
  
                let notesItems = $.grep(this.items,function(o: any){ return o.Notes });
                if(notesItems.length > 0){
                    this.showBlod = true;
                }
  
                this.getSum() 
            }
          }
         
          
      }
      this.printTranjection();   
  }
}

  getSum(){
   
    var sum = 0;
    for(let i = 0; i < this.items.length; i++){
      sum = sum + this.items[i].Total;
    }
    this.total = sum;
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
  }
}
